import { QUOTE_PRODUCT_ID } from '@vertex-protocol/contracts';
import { TOKEN_ICONS } from './tokenIcons';
import { PerpProductMetadata } from './types';

export const BTC_PERP_METADATA: PerpProductMetadata = {
  symbol: 'BTC',
  icon: TOKEN_ICONS.btc,
  marketName: 'BTCUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'chain']),
};

export const ETH_PERP_METADATA: PerpProductMetadata = {
  symbol: 'ETH',
  icon: TOKEN_ICONS.eth,
  marketName: 'ETHUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'chain']),
};

export const ARB_PERP_METADATA: PerpProductMetadata = {
  symbol: 'ARB',
  icon: TOKEN_ICONS.arb,
  marketName: 'ARBUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'chain']),
};

export const BNB_PERP_METADATA: PerpProductMetadata = {
  symbol: 'BNB',
  icon: TOKEN_ICONS.bnb,
  marketName: 'BNBUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'chain']),
};

export const POL_PERP_METADATA: PerpProductMetadata = {
  symbol: 'POL',
  icon: TOKEN_ICONS.pol,
  marketName: 'POLUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'chain']),
};

export const SOL_PERP_METADATA: PerpProductMetadata = {
  symbol: 'SOL',
  icon: TOKEN_ICONS.sol,
  marketName: 'SOLUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'chain']),
};

export const XRP_PERP_METADATA: PerpProductMetadata = {
  symbol: 'XRP',
  icon: TOKEN_ICONS.xrp,
  marketName: 'XRPUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp']),
};

export const SUI_PERP_METADATA: PerpProductMetadata = {
  symbol: 'SUI',
  icon: TOKEN_ICONS.sui,
  marketName: 'SUIUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'chain']),
};

export const OP_PERP_METADATA: PerpProductMetadata = {
  symbol: 'OP',
  icon: TOKEN_ICONS.op,
  marketName: 'OPUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'chain']),
};

export const LTC_PERP_METADATA: PerpProductMetadata = {
  symbol: 'LTC',
  icon: TOKEN_ICONS.ltc,
  marketName: 'LTCUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp']),
};

export const BCH_PERP_METADATA: PerpProductMetadata = {
  symbol: 'BCH',
  icon: TOKEN_ICONS.bch,
  marketName: 'BCHUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp']),
};

export const COMP_PERP_METADATA: PerpProductMetadata = {
  symbol: 'COMP',
  icon: TOKEN_ICONS.comp,
  marketName: 'COMPUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'defi']),
};

export const APT_PERP_METADATA: PerpProductMetadata = {
  symbol: 'APT',
  icon: TOKEN_ICONS.apt,
  marketName: 'APTUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'chain']),
};

export const MKR_PERP_METADATA: PerpProductMetadata = {
  symbol: 'MKR',
  icon: TOKEN_ICONS.mkr,
  marketName: 'MKRUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'defi']),
};

export const MPEPE_PERP_METADATA: PerpProductMetadata = {
  symbol: 'mPEPE',
  icon: TOKEN_ICONS.pepe,
  marketName: 'mPEPEUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'meme']),
};

export const DOGE_PERP_METADATA: PerpProductMetadata = {
  symbol: 'DOGE',
  icon: TOKEN_ICONS.doge,
  marketName: 'DOGEUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'meme']),
};

export const LINK_PERP_METADATA: PerpProductMetadata = {
  symbol: 'LINK',
  icon: TOKEN_ICONS.link,
  marketName: 'LINKUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'defi']),
};

export const DYDX_PERP_METADATA: PerpProductMetadata = {
  symbol: 'DYDX',
  icon: TOKEN_ICONS.dydx,
  marketName: 'DYDXUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'defi']),
};

export const CRV_PERP_METADATA: PerpProductMetadata = {
  symbol: 'CRV',
  icon: TOKEN_ICONS.crv,
  marketName: 'CRVUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'defi']),
};

export const TIA_PERP_METADATA: PerpProductMetadata = {
  symbol: 'TIA',
  icon: TOKEN_ICONS.tia,
  marketName: 'TIAUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'chain']),
};

export const PYTH_PERP_METADATA: PerpProductMetadata = {
  symbol: 'PYTH',
  icon: TOKEN_ICONS.pyth,
  marketName: 'PYTHUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'defi']),
};

export const JTO_PERP_METADATA: PerpProductMetadata = {
  symbol: 'JTO',
  icon: TOKEN_ICONS.jto,
  marketName: 'JTOUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp']),
};

export const AVAX_PERP_METADATA: PerpProductMetadata = {
  symbol: 'AVAX',
  icon: TOKEN_ICONS.avax,
  marketName: 'AVAXUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'chain']),
};

export const INJ_PERP_METADATA: PerpProductMetadata = {
  symbol: 'INJ',
  icon: TOKEN_ICONS.inj,
  marketName: 'INJUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'chain']),
};

export const SNX_PERP_METADATA: PerpProductMetadata = {
  symbol: 'SNX',
  icon: TOKEN_ICONS.snx,
  marketName: 'SNXUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'defi']),
};

export const ADA_PERP_METADATA: PerpProductMetadata = {
  symbol: 'ADA',
  icon: TOKEN_ICONS.ada,
  marketName: 'ADAUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'chain']),
};

export const IMX_PERP_METADATA: PerpProductMetadata = {
  symbol: 'IMX',
  icon: TOKEN_ICONS.imx,
  marketName: 'IMXUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp']),
};

export const MEME_PERP_METADATA: PerpProductMetadata = {
  symbol: 'MEME',
  icon: TOKEN_ICONS.meme,
  marketName: 'MEMEUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'meme']),
};

export const SEI_PERP_METADATA: PerpProductMetadata = {
  symbol: 'SEI',
  icon: TOKEN_ICONS.sei,
  marketName: 'SEIUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'chain']),
};

export const STX_PERP_METADATA: PerpProductMetadata = {
  symbol: 'STX',
  icon: TOKEN_ICONS.stx,
  marketName: 'STXUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp']),
};

export const NEAR_PERP_METADATA: PerpProductMetadata = {
  symbol: 'NEAR',
  icon: TOKEN_ICONS.near,
  marketName: 'NEARUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'chain']),
};

export const BLUR_PERP_METADATA: PerpProductMetadata = {
  symbol: 'BLUR',
  icon: TOKEN_ICONS.blur,
  marketName: 'BLURUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp']),
};

export const LDO_PERP_METADATA: PerpProductMetadata = {
  symbol: 'LDO',
  icon: TOKEN_ICONS.ldo,
  marketName: 'LDOUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'defi']),
};

export const FIL_PERP_METADATA: PerpProductMetadata = {
  symbol: 'FIL',
  icon: TOKEN_ICONS.fil,
  marketName: 'FILUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp']),
};

export const WLD_PERP_METADATA: PerpProductMetadata = {
  symbol: 'WLD',
  icon: TOKEN_ICONS.wld,
  marketName: 'WLDUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp']),
};

export const ICP_PERP_METADATA: PerpProductMetadata = {
  symbol: 'ICP',
  icon: TOKEN_ICONS.icp,
  marketName: 'ICPUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'chain']),
};

export const DOT_PERP_METADATA: PerpProductMetadata = {
  symbol: 'DOT',
  icon: TOKEN_ICONS.dot,
  marketName: 'DOTUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'chain']),
};

export const TRX_PERP_METADATA: PerpProductMetadata = {
  symbol: 'TRX',
  icon: TOKEN_ICONS.trx,
  marketName: 'TRXUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp']),
};

export const GALA_PERP_METADATA: PerpProductMetadata = {
  symbol: 'GALA',
  icon: TOKEN_ICONS.gala,
  marketName: 'GALAUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp']),
};

export const ATOM_PERP_METADATA: PerpProductMetadata = {
  symbol: 'ATOM',
  icon: TOKEN_ICONS.atom,
  marketName: 'ATOMUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'chain']),
};

export const APE_PERP_METADATA: PerpProductMetadata = {
  symbol: 'APE',
  icon: TOKEN_ICONS.ape,
  marketName: 'APEUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp']),
};

export const JUP_PERP_METADATA: PerpProductMetadata = {
  symbol: 'JUP',
  icon: TOKEN_ICONS.jup,
  marketName: 'JUPUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'defi']),
};

export const GMCI30_PERP_METADATA: PerpProductMetadata = {
  symbol: 'GMCI30',
  icon: TOKEN_ICONS.gmci30,
  marketName: 'GMCI30USDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'index']),
};

export const GMMEME_PERP_METADATA: PerpProductMetadata = {
  symbol: 'GMMEME',
  icon: TOKEN_ICONS.gmMeme,
  marketName: 'GMMEMEUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'index']),
};

export const WIF_PERP_METADATA: PerpProductMetadata = {
  symbol: 'WIF',
  icon: TOKEN_ICONS.wif,
  marketName: 'WIFUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'meme']),
};

export const MNT_PERP_METADATA: PerpProductMetadata = {
  symbol: 'MNT',
  icon: TOKEN_ICONS.mnt,
  marketName: 'MNTUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'chain']),
};

export const ENA_PERP_METADATA: PerpProductMetadata = {
  symbol: 'ENA',
  icon: TOKEN_ICONS.ena,
  marketName: 'ENAUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'defi']),
};

export const S_PERP_METADATA: PerpProductMetadata = {
  symbol: 'S',
  icon: TOKEN_ICONS.s,
  marketName: 'SUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'chain']),
};

export const TON_PERP_METADATA: PerpProductMetadata = {
  symbol: 'TON',
  icon: TOKEN_ICONS.ton,
  marketName: 'TONUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'chain']),
};

export const ONDO_PERP_METADATA: PerpProductMetadata = {
  symbol: 'ONDO',
  icon: TOKEN_ICONS.ondo,
  marketName: 'ONDOUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp']),
};

export const BLAST_PERP_METADATA: PerpProductMetadata = {
  symbol: 'BLAST',
  icon: TOKEN_ICONS.blast,
  marketName: 'BLASTUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'chain']),
};

export const AAVE_PERP_METADATA: PerpProductMetadata = {
  symbol: 'AAVE',
  icon: TOKEN_ICONS.aave,
  marketName: 'AAVEUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'defi']),
};

export const EIGEN_PERP_METADATA: PerpProductMetadata = {
  symbol: 'EIGEN',
  icon: TOKEN_ICONS.eigen,
  marketName: 'EIGENUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'defi']),
};

export const ZRO_PERP_METADATA: PerpProductMetadata = {
  symbol: 'ZRO',
  icon: TOKEN_ICONS.zro,
  marketName: 'ZROUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'defi']),
};

export const BRETT_PERP_METADATA: PerpProductMetadata = {
  symbol: 'BRETT',
  icon: TOKEN_ICONS.brett,
  marketName: 'BRETTUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'meme']),
};

export const DEGEN_PERP_METADATA: PerpProductMetadata = {
  symbol: 'DEGEN',
  icon: TOKEN_ICONS.degen,
  marketName: 'DEGENUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'meme']),
};

export const SCR_PERP_METADATA: PerpProductMetadata = {
  symbol: 'SCR',
  icon: TOKEN_ICONS.scr,
  marketName: 'SCRUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'defi']),
};

export const GOAT_PERP_METADATA: PerpProductMetadata = {
  symbol: 'GOAT',
  icon: TOKEN_ICONS.goat,
  marketName: 'GOATUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'meme']),
};

export const TRUMP_PERP_METADATA: PerpProductMetadata = {
  symbol: 'TRUMP',
  icon: TOKEN_ICONS.trump,
  marketName: 'TRUMPUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'meme']),
};

export const BERA_PERP_METADATA: PerpProductMetadata = {
  symbol: 'BERA',
  icon: TOKEN_ICONS.bera,
  marketName: 'BERAUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'chain']),
};

export const XAUT_PERP_METADATA: PerpProductMetadata = {
  symbol: 'XAUT',
  icon: TOKEN_ICONS.xaut,
  marketName: 'XAUTUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'commodity']),
};

// Nado Ink-specific markets

export const HYPE_PERP_METADATA: PerpProductMetadata = {
  symbol: 'HYPE',
  icon: TOKEN_ICONS.hype,
  marketName: 'HYPEUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'defi']),
};

export const ZEC_PERP_METADATA: PerpProductMetadata = {
  symbol: 'ZEC',
  icon: TOKEN_ICONS.zec,
  marketName: 'ZECUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp']),
};

export const MON_PERP_METADATA: PerpProductMetadata = {
  symbol: 'MON',
  icon: TOKEN_ICONS.mon,
  marketName: 'MONUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'chain']),
};

export const FARTCOIN_PERP_METADATA: PerpProductMetadata = {
  symbol: 'FARTCOIN',
  icon: TOKEN_ICONS.fartcoin,
  marketName: 'FARTCOINUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'meme']),
};

export const PUMP_PERP_METADATA: PerpProductMetadata = {
  symbol: 'PUMP',
  icon: TOKEN_ICONS.pump,
  marketName: 'PUMPUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'meme']),
};

export const TAO_PERP_METADATA: PerpProductMetadata = {
  symbol: 'TAO',
  icon: TOKEN_ICONS.tao,
  marketName: 'TAOUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'chain']),
};

export const XMR_PERP_METADATA: PerpProductMetadata = {
  symbol: 'XMR',
  icon: TOKEN_ICONS.xmr,
  marketName: 'XMRUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp']),
};

export const LIT_PERP_METADATA: PerpProductMetadata = {
  symbol: 'LIT',
  icon: TOKEN_ICONS.lit,
  marketName: 'LITUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp']),
};

export const KPEPE_PERP_METADATA: PerpProductMetadata = {
  symbol: 'kPEPE',
  icon: TOKEN_ICONS.pepe,
  marketName: 'kPEPEUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'meme']),
};

export const PENGU_PERP_METADATA: PerpProductMetadata = {
  symbol: 'PENGU',
  icon: TOKEN_ICONS.pengu,
  marketName: 'PENGUUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'meme']),
};

export const USELESS_PERP_METADATA: PerpProductMetadata = {
  symbol: 'USELESS',
  icon: TOKEN_ICONS.useless,
  marketName: 'USELESSUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'meme']),
};

export const UNI_PERP_METADATA: PerpProductMetadata = {
  symbol: 'UNI',
  icon: TOKEN_ICONS.uni,
  marketName: 'UNIUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'defi']),
};

export const ASTER_PERP_METADATA: PerpProductMetadata = {
  symbol: 'ASTER',
  icon: TOKEN_ICONS.aster,
  marketName: 'ASTERUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp']),
};

export const XPL_PERP_METADATA: PerpProductMetadata = {
  symbol: 'XPL',
  icon: TOKEN_ICONS.xpl,
  marketName: 'XPLUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp']),
};

export const WLFI_PERP_METADATA: PerpProductMetadata = {
  symbol: 'WLFI',
  icon: TOKEN_ICONS.wlfi,
  marketName: 'WLFIUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp']),
};

export const KBONK_PERP_METADATA: PerpProductMetadata = {
  symbol: 'kBONK',
  // TODO: add bonk.svg icon
  icon: TOKEN_ICONS.pepe,
  marketName: 'kBONKUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'meme']),
};

export const AXS_PERP_METADATA: PerpProductMetadata = {
  symbol: 'AXS',
  icon: TOKEN_ICONS.axs,
  marketName: 'AXSUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp']),
};

export const SKY_PERP_METADATA: PerpProductMetadata = {
  symbol: 'SKY',
  icon: TOKEN_ICONS.sky,
  marketName: 'SKYUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp', 'defi']),
};

export const VIRTUAL_PERP_METADATA: PerpProductMetadata = {
  symbol: 'VIRTUAL',
  icon: TOKEN_ICONS.virtual,
  marketName: 'VIRTUALUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp']),
};

export const SKR_PERP_METADATA: PerpProductMetadata = {
  symbol: 'SKR',
  icon: TOKEN_ICONS.skr,
  marketName: 'SKRUSDT0',
  quoteProductId: QUOTE_PRODUCT_ID,
  marketCategories: new Set(['perp']),
};
